import styled from 'styled-components'
import Button from 'components/common/input/Button'

/*
 * <LoginButton/>
 */
export default styled(Button)`
  margin-top: 0 !important;
  margin-bottom: 40px !important;
  div > span {
    font-weight: 500 !important;
  }
  width: 208px;
`
